import * as actionTypes from './actionTypes';
import { resetState } from '@app/src/commons/sidebar/state/sidebar/actions';
import { serviceUser } from './services';
import { getHttpReponseCodeMessage } from '@app/src/utils/validations';
import { HttpStatus } from '@app/src/utils/validations/constants';

const fetchLoginRequest = () => ({
  type: actionTypes.FETCH_LOGIN_REQUEST
});

const fetchLoginFailure = (errorMessage: string) => ({
  type: actionTypes.FETCH_LOGIN_FAILURE,
  errorMessage
});

const fetchLoginSuccess = (data) => ({
  type: actionTypes.FETCH_LOGIN_SUCCESS,
  data
});

export const fetchLogin = (values, history, url): Function => {
  return async dispatch => {
    dispatch(fetchLoginRequest());
    try {
      const data = await serviceUser.login(values, url);
      if (data.code === HttpStatus.LOGIN_ERROR) {
        dispatch(fetchLoginFailure(data.message));
        return;
      }
      dispatch(fetchLoginSuccess(data));
      sessionStorage.setItem('accessToken', data.user.accessToken);
      sessionStorage.setItem('reportToken', data.user.reportToken);
      history.push('/generarcip');
    } catch(e) {
      const response = e.response;
      let message = getHttpReponseCodeMessage(e.status, response);
      dispatch(fetchLoginFailure(message));
    }
  }
}

export const userLogout = (history): Function => {
  return dispatch => {
    sessionStorage.clear();
    localStorage.clear();
    history.push('/');
    dispatch(resetState());
  }
}
